module.exports = __webpack_public_path__ + "img/status-true.613f0048.svg";